import React, { useState } from 'react';
import { Login } from './Login';
import { API_LOGIN } from '../../settings';
import { parseJSON } from "../../utils";
import { has } from 'lodash';

const LoginContainer = ({ location }) => {
    const [error, setError] = useState(null);
    let from = new URLSearchParams(location.search).get('from');
    if (from === null) from = "/";

    const onLogin = ({ username, password }) => {
        setError(null);
        fetch(API_LOGIN + '?service=sp_admin', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: username, password: password })
        })
            .then(parseJSON)
            .then((response) => {
                if (response.ok) {
                    window.location = '/#' + decodeURIComponent(from);
                }
                else {
                    const errorMessage = has(response, 'json') && response.json.message ? response.json.message : "Unknown error";
                    setError(`Error ${response.status}: ${errorMessage}.`);
                }
            })
            .catch(error => console.log(error));
    };

    return(
        <Login
            error={error}
            onLogin={onLogin}
        />
    );
};

export { LoginContainer };